import React from 'react';
import { useParams } from 'react-router-dom';
import NoindexRedirect from '../shared/NoindexRedirect';

// Journey wizard removed — redirect to simple tourist paths.
const JOURNEY_REDIRECTS = {
	thinking: { pathname: '/', hash: '#plan' },
	booked: { pathname: '/', hash: '#plan' },
	landed: '/arrival',
	travelling: { pathname: '/', hash: '#places' },
};

function JourneyRedirect() {
	const { stage } = useParams();
	const target = JOURNEY_REDIRECTS[stage] || { pathname: '/', hash: '#places' };
	return <NoindexRedirect path={`/journey/${stage}`} to={target} />;
}

export default JourneyRedirect;
